import { isIntl } from '../react-process-env';
import { LocaleCode } from './locales';

// TODO: 海外和国内的默认语言不通
export const DEFAULT_LOCALE: LocaleCode = isIntl ? 'en' : 'zh-Hans';
